import {PaginationQueryConfig, QueryConfig} from './Types';
import {useState} from 'react';

export const usePaginationQueryConfig = <T>(key: (page: number) => any[], queryFn: (page: number) => Promise<T>): PaginationQueryConfig<T> => {
    const [page, setPage] = useState<number>(1);

    return [{
        queryKey: key(page),
        queryFn: () => queryFn(page),
        keepPreviousData: true,
    }, setPage];
};

export const useQueryConfig = <T>(queryKey: any[], queryFn: () => Promise<T>): [QueryConfig<T>] => {
    return [{ queryKey, queryFn }]
};
